import { css, cx } from '@emotion/css'
import { Routes, Route } from 'react-router-dom'

import { AppShell } from './components/AppShell.jsx'
import { Home } from './pages/Home.jsx'
import { Explore } from './pages/Explore.jsx'
import { Profile } from './pages/Profile.jsx'

const styles = {
  app: css({
    minHeight: '100vh',
  }),
}

const App = () => {
  return (
    <div className={styles.app}>
      <AppShell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </AppShell>
    </div>
  )
}

export { App }
